import { ACTIONS } from '../Constants';

const initialNavState = {
    expandNavigation: false,
    minimalNav: false,
    previousLocation: '',
    returnToInfoSlide: false
};

const navReducer = (state = initialNavState, action) => {
    switch (action.type) {
        case ACTIONS.EXPAND_NAVIGATION: {
            return {
                ...state,
                expandNavigation: true
            };
        }
        case ACTIONS.COLLAPSE_NAVIGATION: {
            return {
                ...state,
                expandNavigation: false
            };
        }
        case ACTIONS.UPDATE_PREVIOUS_LOCATION: {
            return {
                ...state,
                previousLocation: action.previousLocation
            };
        }
        default:
            return state;
    }
};

export default navReducer;
